module.exports = __webpack_public_path__ + "img/chrome-hero.0f61a852.webp";